<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE CONTATO INTERNO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label><small v-show="form.cooperativa.required" class="text-danger">*</small> Cooperativa:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite a Cooperativa'"
                          v-model="form.cooperativa.value"
                          :size="form.cooperativa.maxlength"
                          :required="form.cooperativa.required"
                          :state="form.cooperativa.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label ><small v-show="form.agenciaPA.required" class="text-danger">*</small> PA:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome do PA'"
                          v-model="form.agenciaPA.value"
                          :size="form.agenciaPA.maxlength"
                          :required="form.agenciaPA.required"
                          :state="form.agenciaPA.state"></b-form-input>
          </div>
        </div>
         <div class="col-md-4">
          <label ><small v-show="form.emailInterno.required" class="text-danger">*</small> E-mail:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o E-mail'"
                          v-model="form.emailInterno.value"
                          :size="form.emailInterno.maxlength"
                          :required="form.emailInterno.required"
                          :state="form.emailInterno.state"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ContactInternalModel from '@/shared/models/configurations/contactinternalmodel.js'
import ContactInternalForms from './ci-form.js'
import ContactInternalRepository from '@/shared/http/repositories/configurations/contactinternal.js'

export default {
  name: 'ContactInternalAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ContactInternalModel,
      form: ContactInternalForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (obj && obj.numero) {
        this.form.numero.value = parseInt(obj.numero)
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      ContactInternalRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      ContactInternalRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/contacts/internal/components/add/ciadd.vue